import { Typography } from '@material-ui/core';
import React from 'react';
import { Modal } from 'rsuite';
import { FormatPhone } from '../../../../helpers';
import ButtonSMS from '../../../../helpers/ButtonSMS';
import { errorMapper } from '../../../../helpers/ErrorMappers';
import { alert } from '../../../../helpers/rsuite/Alerts';
import { cuotitasStoreService } from '../../../../services';
import ENABLE from '../../../../constants/enable';

import { ButtonIcon, InfoPoint } from '../../../../components';
import FileTextIcon from '@rsuite/icons/legacy/FileText';
// eslint-disable-next-line no-unused-vars
import SaveIcon from '@rsuite/icons/legacy/Save';
import QRCode from 'react-qr-code';
import HelpOutlineIcon from '@rsuite/icons/HelpOutline';
import useTheme from '../../../../hooks/useTheme';

const body0 = {
    width: '540px',
    padding: '0 4px'
};

const infoPointContent = {
    width: '340px',
    fontSize: '11px',
};

const helpIcon = {
    color: '#3699FF',
    marginLeft: 10,
    fontSize: '1.5em',
    cursor: 'pointer',
};

export function DigitalSignStep (context) {
    const theme = useTheme();

    const hash = context?.sign?.hash;
    const idSignRequest = context?.sign?.id;
    const telephone = context.formMainUser?.cellPhoneAreaCode + context.formMainUser?.cellPhoneCharacteristic + context.formMainUser?.cellPhoneNumber;

    const sendSMS = () => {
        context.setIsLoading(true);
        const data = {
            idSignRequest: idSignRequest,
            link: `${theme.linkUrl}/${hash}`,
            telephone: FormatPhone(telephone)
        };

        return cuotitasStoreService
            .sendSMS(data)
            .then(res => {
                alert('success', 'SMS enviado correctamente.');
                context.setButtonSmsClicked(true);
                return true;
            })
            .catch(e => {
                console.error(e);
                const msg = errorMapper(e);
                e.msg = msg;
                const submitToast = () => context.submitToast(e);
                alert(msg?.type, msg?.message, 0, 'topCenter', submitToast);
                return false;
            })
            .finally(() => context.setIsLoading(false));
    };

    return (
        <>
            <Modal.Body className='mb-5 h-100 py-1' style={{ height: '540px' }}>
                <div className='row m-0' style={body0}>
                    <div className='flex col justify-content-center mx-auto w-100'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <h6 className=''>Escanea el código QR para firmar tu préstamo</h6>
                            <InfoPoint
                                placement="left"
                                content={
                                    <div style={infoPointContent}>
                                        <p className='m-1'>Para escanear este código, podés usar tu cámara o una aplicación de escaneo QR de tu teléfono.</p>
                                    </div>
                                }
                            >
                                <HelpOutlineIcon style={helpIcon} />
                            </InfoPoint>
                        </div>
                        <div className='d-flex justify-content-center w-100 mt-6 mb-6'>
                            <QRCode value={`${theme.linkUrl}/${hash}`} size={250} />
                        </div>
                    </div>
                    <div className='d-flex justify-content-between align-items-center'>
                        {
                            ENABLE.enableDownloandReportError && <div id='download-test' className='download-test' style={{ aligneContent: 'right' }}>
                                <ButtonIcon
                                    title='Descargar prueba de concepto'
                                    size='medium'
                                    icon={(<FileTextIcon />)}
                                    // icon={(<SaveIcon />)}
                                    onClick={() => context.downloandReportTest()}
                                    disabled={context.isLoading}
                                />
                            </div>
                        }
                        {
                            context.buttonSmsClicked ? <Typography>Para reenviar el link podrá hacerlo desde la bandeja de pendientes</Typography> : <h7 className='sign-link'>{`Link: ${theme.linkUrl}/${hash}`}</h7>
                        }
                        <div>
                            {
                                !context.buttonSmsClicked && <ButtonSMS sendSMS={sendSMS} timeDisable='30' description='Enviar SMS' id='sendSMS-GA' telephone={true} />
                            }
                        </div>
                    </div>
                </div>
            </Modal.Body>
            {/* <Modal.Footer className='mt-4'>
                <div>
                    <></>
                    <Button appearance='primary' disabled={context.isLoading} onClick={context.acceptAndCloseModal} >Aceptar</Button>
                </div>
            </Modal.Footer> */}
        </>
    );
};
